/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScorecardDefinitionCreateFieldsItem } from './scorecardDefinitionCreateFieldsItem';
import type { SelectionRuleIn } from './selectionRuleIn';

export interface ScorecardDefinitionCreate {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name: string;
  fields: ScorecardDefinitionCreateFieldsItem[];
  selection_rule?: SelectionRuleIn | null;
  position?: number | null;
  is_default?: boolean | null;
}
